import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getRoles() {
  try {
    const roles = yield call(API.getRoles);
    yield put({ type: actionTypes.ROLES_GET_SUCCESS, roles });
  } catch (error) {
    yield put({ type: actionTypes.ROLES_GET_ERROR, error });
  }
}

export function* getOwnershipTypes() {
  try {
    const data = yield call(API.getOwnershipTypes);
    yield put({ type: actionTypes.OWNERSHIP_TYPES_GET_SUCCESS, data });
  } catch (error) {
    yield put({ type: actionTypes.OWNERSHIP_TYPES_GET_ERROR, error });
  }
}

export function* getContractBlocks() {
  try {
    const data = yield call(API.getContractBlocks);
    yield put({ type: actionTypes.CONTRACT_BLOCKS_GET_SUCCESS, data });
  } catch (error) {
    yield put({ type: actionTypes.CONTRACT_BLOCKS_GET_ERROR, error });
  }
}

export function* getWorkTypes() {
  try {
    const data = yield call(API.getWorkTypes);
    yield put({ type: actionTypes.WORK_TYPES_GET_SUCCESS, data });
  } catch (error) {
    yield put({ type: actionTypes.WORK_TYPES_GET_ERROR, error });
  }
}

export function* getSubWorkTypes() {
  try {
    const data = yield call(API.getSubWorkTypes);
    yield put({ type: actionTypes.SUBWORK_TYPES_GET_SUCCESS, data });
  } catch (error) {
    yield put({ type: actionTypes.SUBWORK_TYPES_GET_ERROR, error });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/global.js